function activateQuizSessionTimer() {
  const $quizSessionTimer = $("#quiz-session-timer");

  if (!$quizSessionTimer.length) return;

  const timeLeft = document.querySelector('#quiz-session-time-left').getAttribute('data-time-left');
  const deadline = new Date();

  deadline.setSeconds(deadline.getSeconds() + Number(timeLeft));

  $quizSessionTimer.countdown(deadline, function(event) {
    this.innerHTML = event.strftime('%H:%M:%S');
  }).on('finish.countdown', function() {
    const $quizTaker = $('#quiz-taker');
    if ($quizTaker.length) $quizTaker.submit();
  });
}

export default activateQuizSessionTimer;
